import { Store } from '@tanstack/react-store'

type SessionState = {
  organizationUid: string
  sessionUid: string
}

export const sessionStore = new Store<SessionState>({
  organizationUid: 'missing',
  sessionUid: 'unknown',
})

export const setOrganizationUid = (organizationUid: string) => {
  sessionStore.setState((s) => ({ ...s, organizationUid }))
}

export const setSessionUid = (sessionUid: string) => {
  sessionStore.setState((s) => ({ ...s, sessionUid }))
}

export const getSessionState = () => sessionStore.state

export const transcriptionStore = new Store('')
